module.exports = __webpack_public_path__ + "img/logo-h-full-forswitch.c4f0e040.png";